module.exports = __webpack_public_path__ + "fonts/AvenirRoman.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AvenirRoman.woff2
// module id = 474
// module chunks = 12